import { AddOrUpdateProductFormData } from "./config";
import { ProductItem } from "./types";

export function getAddPayload(
  formData: AddOrUpdateProductFormData
): { category: string; isSatisfied: boolean } {
  return {
    category: formData.category,
    isSatisfied: formData.isSatisfied ?? false,
  };
}

export function getUpdatePayload(
  formData: AddOrUpdateProductFormData
): { category: string; isSatisfied: boolean } {
  return {
    category: formData.category,
    isSatisfied: formData.isSatisfied ?? false,
  };
}

export function mapDataToFormValues(
  data: ProductItem | null
): AddOrUpdateProductFormData {
  if (!data) {
    return {
      category: "",
      isSatisfied: false,
    };
  }
  return {
    category: data.category ?? "",
    isSatisfied: data.isSatisfied ?? false,
  };
}
